<template>
<div ui-view="" class="app-body" id="view">
	<page-header title="보안 등급 설정" description="IDC 출입 A,B 등급 조직을 관리합니다. A,B 등급에 속한 출입자는 출입 신청 없이 임직원 입실이 가능합니다. (공공,금융,전자서명 존 제외)"/>
	<div class="page-body ph-30">
		<div class="box mt-20">
			<div class="box-header">
				<h3>업무분장단위 IDC 보안등급 설정</h3>
				<p>조직 단위로 IDC 입실을 위한 보안 등급을 설정합니다.</p>
				<p>상위 조직 선택 시, 기본적으로 하위 조직을 모두 포함합니다.</p>
			</div>
			<div class="box-body">
				<div class="row">
					<div class="col-5">
						<secure-table title="업무분장" ref="mainList" :isSearch="true" height="925" :datasource="items"
						:grade="null" :is-dropdown="false" @selectRow="selectRow" @search="search"/>
					</div>
					<div class="col-1" style="display: flex;
						align-items: center;
						justify-content: center;">
						<div class="transfer-controls" style="display: flex;flex-direction: column;height: 100%;">

							<div class="transfer-controls" style="display: flex;flex-direction: column;justify-content: center;flex:1">
								<button class="btn btn-l line-4 ltr" :disabled="!isDrop" @click="updateItem(items, 'Am', 0)">
									<i class="icon-arrow-line-right-centered"></i>
								</button>
								<button class="btn btn-l line-4 rtl mt-6" :disabled="!isBackAmDrop" @click="updateItem(gradeAmItems)">
									<i class="icon-arrow-line-left-centered"></i>
								</button>
							</div>

							<div class="transfer-controls" style="display: flex;flex-direction: column;justify-content: center;flex:1">
								<button class="btn btn-l line-4 ltr" :disabled="!isDrop" @click="updateItem(items, 'A', 0)">
									<i class="icon-arrow-line-right-centered"></i>
								</button>
								<button class="btn btn-l line-4 rtl mt-6" :disabled="!isBackADrop" @click="updateItem(gradeAItems)">
									<i class="icon-arrow-line-left-centered"></i>
								</button>
							</div>

							<div class="transfer-controls" style="display: flex;flex-direction: column;justify-content: center;flex:1">
								<button class="btn btn-l line-4 ltr" :disabled="!isDrop" @click="updateItem(items, 'B', 0)">
									<i class="icon-arrow-line-right"></i>
								</button>

								<button class="btn btn-l line-4 rtl mt-6" :disabled="!isBackBDrop"  @click="updateItem(gradeBItems)">
									<i class="icon-arrow-line-left"></i>
								</button>
							</div>

						</div>
					</div>
					<div class="col-6">
						<secure-table title="Am등급" height="225" :datasource="gradeAmItems" :is-dropdown="true" grade="Am" description="NAVER Cloud 내 IDC 관련 직접적인 업무 연관성이 있는 조직"
									  @selectRow="selectRowAm"/>
						<br/>
						<secure-table title="A등급" height="225" :datasource="gradeAItems" :is-dropdown="true" grade="A" description="NAVER Cloud 내 IDC 관련 직접적인 업무 연관성이 있는 조직"
						@selectRow="selectRowA"/>
						<br/>
						<secure-table title="B등급" height="225" :datasource="gradeBItems" :is-dropdown="true" grade="B" description="NAVER 그룹사 내 IDC 연관 법인 및 조직"
						 @selectRow="selectRowB"/>
					</div>
				</div>

				<p class="mt-10" style="color:#f84d3a"><span class="ess red"></span><span class="ml-10">선택후 화살표 클릭시 즉시 반영됩니다.</span></p>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue'
import SecureTable from './secureLevel/SecureTable.vue'
export default {
  props: ['title', 'description'],
	data(){
		return {
			levelItems: [],
			items: null,
			gradeAmItems: null,
			gradeAItems: null,
			gradeBItems: null,
		}
	},
	mounted(){

		this.init();
	},
	updated() {
		$.getScript( "/libs/jquery/mCustomScrollbar/jquery.mCustomScrollbar.concat.min.js", function( data, textStatus, jqxhr ) {
			console.log( jqxhr.status ); // 200
			console.log( "Load was /libs/js/egjs/infinitegrid.pkgd.min.js" );
		});
	},
	computed: {
		isDrop(){
			if(this.items)
				return this.items.filter(x=>x.checked).length > 0
		},
		isBackAmDrop(){
			if(this.gradeAmItems)
				return this.gradeAmItems.filter(x=>x.checked).length > 0
		},
		isBackADrop(){
			if(this.gradeAItems)
				return this.gradeAItems.filter(x=>x.checked).length > 0
		},
		isBackBDrop(){
			if(this.gradeBItems)
				return this.gradeBItems.filter(x=>x.checked).length > 0
		}
	},
	methods: {
		init(){
			// this.loadItems();
			this.loadAmItems();
			this.loadAItems();
			this.loadBItems();
		},
		loadItems(term){
			var query = '';
			if(term)
				query = '?' + $.param({deptName: term})
			this.$http.get('/api/private/department' + query).then((result) =>{
				this.items = result.data;
			});
		},
		loadAmItems(){
			this.$http.get('/api/private/department?idcGrade=Am').then((result) =>{
				this.gradeAmItems = result.data;
			});
		},
		loadAItems(){
			this.$http.get('/api/private/department?idcGrade=A').then((result) =>{
				this.gradeAItems = result.data;
			});
		},
		loadBItems(){
			this.$http.get('/api/private/department?idcGrade=B').then((result) =>{
				this.gradeBItems = result.data;
			});
		},
		updateItem(items, idcGrade, isContainChildren){
			debugger;
			var that = this;
			var checkedList = items.filter(x=>x.checked);
			var checkedListArr = checkedList.map(x=>x.teamCode).join(',');

			var o = {};
			if(idcGrade)
				o.idcGrade = idcGrade;
			//if(isContainChildren) 으로 할 시 0이여서 false 로 인식 함.
			if(isContainChildren != null)
				o.isContainChildren = isContainChildren;
			debugger;
			console.log('/api/private/department/' + checkedListArr + '?' + $.param(o));
			debugger;
			this.$http.put('/api/private/department/' + checkedListArr + '?' + $.param(o)).then((result) =>{
				debugger;
				that.init();
			});

		},
		search(term){
			this.loadItems(term);
		},
		selectRow(data){
			this.items = data;
		},
		selectRowAm(data){
			this.gradeAmItems = data;
		},
		selectRowA(data){
			this.gradeAItems = data;
		},
		selectRowB(data){
			this.gradeBItems = data;
		}
	},
	components: {
		PageHeader,
		SecureTable
	}
}
</script>

<style>

</style>
